module.exports = __webpack_public_path__ + "static/media/intro.a159aec3.mp3";